// исходник, уехавший в прод вместе с картой
const ADMIN_PASSWORD = 'admin123';
const STRIPE = 'sk_live_STENDdemoNOTaREALkeyAAAAAAAAAAAAAAAA';
